import { Reveal, stagger, item } from "./motion";
import { motion } from "framer-motion";
import { HONORS } from "@/data";
import { Trophy } from "lucide-react";

export const Honors = () => (
  <section className="py-24 sm:py-32 bg-[#F6F4EE]" data-testid="honors">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline text-[#B9735A] mb-5">Academic Excellence</p>
        <h2 className="font-serif-display font-light text-4xl sm:text-6xl text-[#1A1C1A] tracking-tight max-w-3xl">
          Honors &amp; <span className="italic text-[#B9735A]">recognitions</span>
        </h2>
      </Reveal>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="mt-12 grid sm:grid-cols-2 gap-4"
      >
        {HONORS.map((h, i) => (
          <motion.div
            key={i}
            variants={item}
            className="rounded-2xl bg-white border border-black/5 p-6 flex gap-4 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300"
            data-testid={`honor-${i}`}
          >
            <div className="w-10 h-10 rounded-xl bg-[#B9735A]/10 text-[#B9735A] flex items-center justify-center shrink-0">
              <Trophy size={18} />
            </div>
            <p className="text-[#4A4D4A] leading-snug">{h}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
